module.exports = __webpack_public_path__ + "img/banner-escritorio.e296acd8.jpeg";